<template>
  <section id="print" class="flex flex-wrap bg-white">
    <div
      id="printimage"
      class="lg:w-1/2 bg-white lg:bg-gsray-100 bg-black flex justify-start align-center items-start p-4 md:p-4 lg:sticky top-0  md:h-full"
    >
      <img
        src="@/assets/images/loveprint.png"
        alt="Corey Bulpitt, LOVE"
        width="1027" height="1027"
        class="object-fit "
      />
    </div>

    <div
      id="printinfo"
      class="lg:w-1/2 flex flex-wrap items-start bg-white p-4 md:pb-12 md:p-10"
    >
      <div id="printintro" class="w-full text-2xl md:text-4xl p-1 leading-tight mb-10">
        <p>
          <strong>Corey Bulpitt</strong> reimagines the iconic LOVE sculpture by
          Robert Indiana, infusing American pop art with traditional Northwest
          Coast imagery by transforming the O into a formline salmon head.
        </p>
      </div>

      <div id="printvitals" class="md:w-1/2 p-1 align-top items-start text-lg mb-6">
        <p class="max-w-xs">
          Corey Bulpitt
          <br />
          LOVE
          <br />
          2020
          <br />
          digital print — signed, numbered, framed
          <br />
          20” × 20”
          <br />
          <br />
          Edition of 25
          <br />
          <br />
          $2,000 each
          <br />
          <br />
          Courtesy of
          <a href="https://fazakasgallery.com/">Fazakas Gallery</a>
          and the artist
        </p>
      </div>

      <div id="coreybio" class="md:w-1/2  text-lg">
        <p class="mb-8">
          Corey Bulpitt (b.1978), also known as Taakeit Aaya or “Gifted Carver”
          by the Haida of the Naikun Raven clan, was born in Prince Rupert, BC.
          An avid painter, jeweler and carver, he has also employed spray paint
          to create murals involving urban youth in Vancouver. Bulpitt is a
          member of the newly emerged Beat Nation Live arts collective. In 2017,
          he received the BC Creative Achievement Award for First Nations Art
          for Artistic Excellence in both traditional and contemporary visual
          art.
        </p>

        <div id="printsponsors" class="text-sm">
          Sponsored by
          <div id="urbaconlogo" class="mb-8 mt-2">
            <a href="http://www.urbacon.net/"
              ><img src="@/assets/svg/urbacon_logo.svg" alt="Urbacon Logo"
            /></a>
          </div>
          With in-kind support from
          <br />
          ABC Photo Ltd.
          <br />
          Akau Framing &amp; Art
        </div>
      </div>

      <div id="purchase" class="w-full mt-10 mb-3">
        <AnimatedButton href="#purchaseprint" id="purchaseprint" class="text-4xl lg:pt-4"  @click.native="showWidget = !showWidget" >
          <svg id="purchase_svg" viewBox="0 0 330 190">
            <path
              class="circle"
              stroke="#19324F"
              stroke-width="7"
              stroke-linecap="round"
              d="M211,12.39C155.58-.24,95,11.9,48.63,44.91,31.48,57.12,15.65,73,10,93.33c-1.34,4.84-2.06,10-1,14.9.94,4.48,3.29,8.53,5.6,12.48,4.09,7,8.21,14,13.57,20.13,8.51,9.66,19.8,16.47,31.5,21.83,33.67,15.42,71.65,19.69,108.6,17.22s73.16-11.41,108.8-21.47c14.91-4.2,30.86-9.36,40-21.89,12.19-16.79,7.43-40.78-3.06-58.67-13.44-22.93-35.29-40.6-60.16-50s-52.58-10.6-78.46-4.53"
              style="fill: none"
            />
          </svg>

          Purchase</AnimatedButton>
                    <iframe v-show="showWidget" width="100%" height="1600" src="https://caseyhouse.com/love/purchase.html" frameborder="0" id="bbox-root" scrolling="no">
                    </iframe>
      </div>
    </div>
  </section>
</template>

<script>
 import AnimatedButton from "@/components/AnimatedButton.vue";


export default {
 
  name: "Print",
  components:{
    AnimatedButton
  },
  watch:{

  //     showWidget(newval,oldval) {
  //     var iFrameID = document.getElementById('bbox-root');
  //             console.log("scrolltent", iFrameID.contentWindow.document.body.scrollHeight );

  //     if(iFrameID) {
  //           // here you can make the height, I delete it first, then I make it again
  //           iFrameID.height = "";
  //           iFrameID.height = iFrameID.contentWindow.document.body.scrollHeight + "px";
  //     }   
  // }

  },
  methods:{

  },
  data: function() {
    return {
      showWidget: false,
    };
  },
  mounted() {

  },
};
</script>

<style scoped>
#printimage {
}

#print{
  /* margin-top:100vh; */
}

#purchase a{
  cursor: pointer;
}

#printimage img {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}
</style>
